// src/hooks/useConfig.js
import React, { createContext, useContext, useState } from "react";

const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState({
    title: "Audio Assistant",
    description: "Assistant for audio and transcriptions",
    github_link: "",
    settings: {
      inputs: { mic: true, camera: false, sip: true },
      outputs: { audio: true, video: false },
      room: "",
      token: "",
      ws_url: "",
      editable: true,
      theme_color: "cyan",
      chat: true,
    },
    video_fit: "cover",
  });

  const setUserSettings = (settings) => {
    setConfig((prev) => ({
      ...prev,
      settings: { ...prev.settings, ...settings },
    }));
  };

  return (
    <ConfigContext.Provider value={{ config, setUserSettings }}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => useContext(ConfigContext);
